import { Box } from '@mui/material';

import type { WallBoard, WallCard } from '@walls/store';
import { CardBody } from './CardBody';
import { CardFrame } from './CardFrame';
import { CardOwnerLabel } from './CardOwnerLabel';
import { useCardPermissions } from './hooks/useCardPermissions';
import { useParticipantName } from './hooks/useParticipantName';
import { getCardFrameDimensions } from './utils/cardGeometry';

interface CircleCardProps {
  board: WallBoard;
  card: WallCard;
  isClusterChild?: boolean;
  measureDependencies?: unknown[];
}

export function CircleCard({
  board,
  card,
  isClusterChild = false,
  measureDependencies = [],
}: CircleCardProps) {
  const dimensions = getCardFrameDimensions(card);
  const permissions = useCardPermissions(board, card);
  const participantName = useParticipantName(card.ownerId);
  const ownerName = permissions.showOwnerName ? participantName : '';

  return (
    <CardFrame
      board={board}
      card={card}
      isClusterChild={isClusterChild}
      measureDependencies={measureDependencies}
      sx={{
        boxShadow: 'none',
        filter: card.isLocked ? 'none' : 'drop-shadow(0 1px 0 rgba(0, 0, 0, 0.2))',
        height: dimensions.height,
        minHeight: 100,
        minWidth: 100,
        overflow: 'visible',
        width: dimensions.width,
      }}
    >
      <Box
        sx={{
          bgcolor: card.color || '#ffff99',
          borderRadius: '50%',
          display: 'flex',
          flex: 1,
          minHeight: 0,
          overflow: 'hidden',
        }}
      >
        <CardBody board={board} card={card} centered />
      </Box>
      <CardOwnerLabel ownerName={ownerName} placement="below" />
    </CardFrame>
  );
}
